import TrojanHeader from '@Components/HeaderApplication/TrojanHeader';
import backgroundImg from '@Images/gradient-background.jpg';
import Flex from 'antd/es/flex';
import { FC, ReactNode } from 'react';
import styles from './SheetMobileLayout.module.css';

interface SheetMobileLayoutProps {
  children: ReactNode;
  header: ReactNode;
}

const SheetMobileLayout: FC<SheetMobileLayoutProps> = ({
  children,
  header,
}) => {
  return (
    <Flex
      vertical
      style={{ backgroundImage: `url(${backgroundImg})` }}
      className={styles.layout}
    >
      <TrojanHeader>
        <Flex className={styles.headerActionItemsSection}>{header}</Flex>
      </TrojanHeader>
      {children}
    </Flex>
  );
};

export default SheetMobileLayout;
